module.exports = __webpack_public_path__ + "media/images/plans/photo_location/photo_location-3-2-b01a5ffde5c58f13fadb5aed10791866.png";